import { renameKeys } from "./utils";

export const asosBreakpoints = {
  mobile: "(max-width: 767px)",
  tablet: "(min-width: 768px) and (max-width: 1023px)",
  desktop: "(min-width: 1024px)",
};

export const postCssCustomMediaQueryConfig = {
  customMedia: {
    ...renameKeys(asosBreakpoints, (key) => `--asos-${key}`),
  },
};
